
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { type NestedPage } from '../../../services/fourwaves/models';
import { Collapsible } from '../../layout';
import WebsiteNavigationNestedLink from './WebsiteNavigationNestedLink.vue';
import { v4 as uuid } from 'uuid';

@Component({ components: { Collapsible, WebsiteNavigationNestedLink } })
export default class WebsiteNavigationNestedDropdown extends Vue {
  @Prop({ type: Object, required: true }) page!: NestedPage;
  @Prop({ type: Boolean, default: false }) readOnly!: boolean;

  uniqueId = uuid();
  isDropdownOpen = false;

  get rootTabIndex(): number {
    return this.readOnly ? -1 : 0;
  }

  get nestedLinksTabIndex(): number {
    return this.isDropdownOpen ? 0 : -1;
  }
}
